export default {
    locale: "Bahasa Indonesia",
    mainSectionText1: "Kami membuat aplikasi² Qurani & software² lain",

    tajwidTagline1: "Aplikasi rekomendasi ulama",
    tajwidTagline1Row2: "untuk belajar Tajwid dengan mudah, telah digunakan jutaan pengguna di seluruh dunia",
    tajwidTagline1Bold: "",
    tajwidTagline1AfterBold: "",

    textProductTajwid2: "Keunggulan yang membuat kamu lancar membaca Quran",
    poin1Tajwid: "Efektif",
    poin2Tajwid: "Kualitas tinggi",
    poin3Tajwid: "Efisien",
    poin4Tajwid: "Komprehensif",
    poin5Tajwid: "Terverifikasi",
    learnMoreTajwid: "Lebih Lanjut",

    qtvTagline1: "Aplikasi",
    qtvTagline1Row2: "Mushaf Quran",
    qtvTagline1Bold: "terbaik untuk",
    qtvTagline1AfterBold: "platform Smart TV",
    qtvTagline1Row3: "إِنْ شَاءَ ٱللَّٰهُ !",

    learnMoreQtv: "Lebih lanjut",

    poin1Qtv: "Dibuat khusus untuk platform TV",
    poin2Qtv: "Dapat diakses Offline",
    poin3Qtv: "Dioptimalkan untuk membaca dan menampilkan",
    poin4Qtv: "Mudah digunakan",
    poin5Qtv: "Easy to Use",
    poin6Qtv: "Kaya fitur",

    tafsirTagline1: "Aplikasi berkualitas tinggi",
    tafsirTagline1Row2: "untuk belajar",
    tafsirTagline1Bold: "memahami",
    tafsirTagline1AfterBold: "Al-Qur'an",

    poin1Tafsir: "Ragam Tafsir",
    poin2Tafsir: "Tampilan Menarik",
    poin3Tafsir: "Fitur Pencarian",
    poin4Tafsir: "Kualitas Tinggi",
    poin5Tafsir: "Sumber Terpercaya",
    poin6Tafsir: "Kapan pun, Di mana pun",

    learnMoreTafsir: "Lebih Lanjut",

    impactUsers: "PENGGUNA",
    impactUsers2: "indonesia",
    impactCountries: "NEGARA",
    impactMinutesUsage: "MENIT PENGGUNAAN",

    textAward1: "Penghargaan",
    textAward2: "Penghargaan",
    textAward3: "Juara 1",
    textAward4: "Aplikasi Ter-inovatif",

    textPublishedBy1: "Dipublikasikan Oleh",
    textPublishedBy2: "dan media lainnya...",

    textPartners1: "Mitra",

    siteMapCol2Row1: "Layanan Jasa",
    siteMapCol2Row2: "Pembuatan Software untuk Anda",
    siteMapCol2Row3: "Belajar bersama Guru Ngaji",
    siteMapCol2Row4: "Tentang Quran Mushaf",
    siteMapCol2Row5: "Peluang Amal Jariyah",
    siteMapCol2Row6: "Postingan",
    siteMapCol2Row7: "Beriklan bersama Kami",

    siteMapCol3Row1: "Mitra Kami",
    siteMapCol3Row2: "BAZNAS",
    siteMapCol3Row3: "BEKRAF",
    siteMapCol3Row4: "Code Margonda",
    siteMapCol3Row5: "FUSI Foundation",

    siteMapCol4Row1: "Produk",
    siteMapCol4Row2: "Learn Quran Tajwid",
    siteMapCol4Row3: "Learn Quran Tafsir",
    siteMapCol4Row4: "Quran Mushaf Apps",
    siteMapCol4Row5: "LQTafsir Android",
    siteMapCol4Row5B: "LQTafsir iOS",
    siteMapCol4Row6: "Quran Mushaf Android TV",
    siteMapCol4Row7: "Quran Mushaf Fire TV",
    siteMapCol4Row8: "Quran Mushaf Samsung TV",

    siteMapCol5Row1: "Akun Resmi",

    textCopyright1: "Hak Cipta",

    textService: "Kami juga menyediakan layanan jasa pembuatan software",
};